import { useState } from "react";
import SearchBar from "./components/SearchBar";
import MovieList from "./components/MovieList";

function App() {

  const [movies, setMovies] = useState([]);

  const API_KEY = "4da71f63";

  const searchMovies = async (query) => {

    const response = await fetch(
      `https://www.omdbapi.com/?s=${query}&apikey=${API_KEY}`
    );

    const data = await response.json();

    setMovies(data.Search || []);
  };

  return (
    <div>

      <h1>Movie App</h1>

      <SearchBar searchMovies={searchMovies} />

      <MovieList movies={movies} />

    </div>
  );
}

export default App;
